import { useContext } from "react";
import { Row } from "react-bootstrap";
import CreateOrderContext from "../../context/createOrder";
import InputField from "../forms/Field";

const CustomerDetails = () => {
  const {
    first_name,
    last_name,
    street,
    house_number,
    zipcode,
    city,
    phone,
    email,
  } = useContext(CreateOrderContext);

  return (
    <>
      <Row>
        <InputField
          label="Voornaam"
          set={first_name.set}
          sizes={{ xs: 12, sm: 6 }}
          value={first_name.value}
          parse={String}
        />

        <InputField
          label="Achternaam"
          set={last_name.set}
          sizes={{ xs: 12, sm: 6 }}
          value={last_name.value}
          parse={String}
        />
      </Row>

      <Row>
        <InputField
          label="Straat"
          set={street.set}
          sizes={{ xs: 6, sm: 6 }}
          value={street.value}
          parse={String}
        />

        <InputField
          label="Huisnummer"
          set={house_number.set}
          sizes={{ xs: 6, sm: 6 }}
          value={house_number.value}
          parse={String}
        />
      </Row>

      <Row>
        <InputField
          label="Postcode"
          set={zipcode.set}
          sizes={{ xs: 6, sm: 6 }}
          value={zipcode.value}
          parse={String}
        />

        <InputField
          label="Plaats"
          set={city.set}
          sizes={{ xs: 6, sm: 6 }}
          value={city.value}
          parse={String}
        />
      </Row>

      <Row>
        <InputField
          label="Telefoon (10 cijfers)"
          set={phone.set}
          sizes={{ xs: 6, sm: 6 }}
          value={phone.value}
          parse={String}
          min={10}
          max={10}
        />

        <InputField
          label="Email"
          set={email.set}
          sizes={{ xs: 6, sm: 6 }}
          value={email.value}
          parse={String}
          type="email"
        />
      </Row>
    </>
  );
};

export default CustomerDetails;
